'use client'
import { useIndustriesNavbarScroll } from '@/Hooks'
import React from 'react'
import IndHeroSection from './components/IndHeroSection'
import IndSectionTwo from './components/IndSectionTwo'
import FiFromStrategy from './components/FiFromStrategy'
import {
   ContactUsForm,
   FAQs,
   GameChangingIdea,
   WordsOfAppreciation,
} from '@/components'

import TopNotchFeatures from './components/TopNotchFeatures'
import HealthFitnessWhyChoose from './components/HealthFitnessWhyChoose'
import SectorsWeEmpower from './components/SectorsWeEmpower'

const faqData = [
   {
      question: 'What is health and fitness software development?',
      answer:
         'It’s about building apps and platforms that help people track workouts, stay on top of their health, connect with wearables, get virtual coaching, or even talk to doctors through telehealth tools.',
   },
   {
      question: 'Why do businesses need custom health and fitness software?',
      answer:
         'Because most ready-made apps don’t fit how every gym or health business works. When you build your own, it’s easier to set things up around what your team does and what your clients need day to day.',
   },
   {
      question: 'What are the key features of a health and fitness app?',
      answer:
         'The typical fitness application combines workout trackers with dietary organizers along with wearable device integration and confirms operational progress simultaneously using artificial intelligence for instructional purposes and it sends alerts and applies game-based mechanics to retain user interest.',
   },
   {
      question: 'How do AI and machine learning improve fitness apps?',
      answer:
         'AI looks at your health data to suggest workouts, spot patterns, and give virtual coaching. It can even predict injury risks or adjust routines based on how your body’s responding over time.',
   },
   {
      question:
         'How does health and fitness software integrate with wearables?',
      answer:
         'It connects through APIs. So if someone’s wearing a Fitbit or an Apple Watch, the app can just grab data straight from it — steps, heart rate, whatever — and you don’t have to type anything in.',
   },
   {
      question:
         'What are the benefits of HIPAA-compliant fitness and healthcare apps?',
      answer:
         'They help keep personal health info private. Everything’s encrypted, and it follows the rules. If you’re doing anything medical or clinical, you kind of need it.',
   },
   {
      question:
         'How long does it take to develop a fitness or health software solution?',
      answer:
         "Hard to say without knowing what you're building. Could be quick, could take a while. Depends what’s in it. A basic fitness app could require 3 to 6 months. Something more complex, like telehealth or AI tools, could take closer to a year to fully build and launch.",
   },
   {
      question:
         'What technologies are used in health and fitness software development?',
      answer:
         'Most of the time it’s a mix of things — AI for coaching, cloud for saving data, connected devices like watches and bands, and APIs to pull in info from other tools people are already using. Blockchain might show up too if records need to be locked down.',
   },
   {
      question:
         'What factors influence the cost of developing a health and fitness app?',
      answer:
         'Cost mostly comes down to how complex it is. Design, features, device connections, privacy rules like HIPAA — all of that plays a part. The more you want the app to do, the more time and cost it usually takes.',
   },
   {
      question:
         'How can Benzatine help with health and fitness software development?',
      answer:
         'We build custom tools for fitness and health brands — whether that means an AI-powered app, a secure telehealth platform, or software that works with wearables and helps you scale smarter.',
   },
];
 
function HealthAndFitnessPage() {
   useIndustriesNavbarScroll()

   return (
      <>
         <IndHeroSection />
         <IndSectionTwo />

         <TopNotchFeatures />

         <FiFromStrategy />
         <SectorsWeEmpower />
         <HealthFitnessWhyChoose />

         <GameChangingIdea />
         <section className="section appreciation-slider-section page_top_section section_secondary_bg">
            <WordsOfAppreciation />
         </section>

         <FAQs faqsConst={faqData} />

         <ContactUsForm />
      </>
   )
}

export default HealthAndFitnessPage
